<template>
  <el-dialog
      title="Sửa ca"
      :visible.sync="isOpenUpdateShiftMasterDialog"
      width="1150px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      @open="handleOpen"
      top="4vh"
  >
    <el-form
        label-width="160px"
        :model="dataInput"
        label-position="left"
        :rules="rules"
        ref="dataInput"
    >
      <el-row :gutter="20">
        <el-col>
          <el-form-item label="Tên ca" prop="name">
            <el-input v-model="dataInput.name" placeholder="Nhập tên ca"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <el-form-item label="Mô tả" prop="description">
            <el-input
                :rows="3"
                type="textarea"
                autosize
                v-model="dataInput.description"
                placeholder="Nhập mô tả"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Thời gian bắt đầu ca" prop="startTime">
            <el-time-picker
                v-model="dataInput.startTime"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
                @change="handleChangeStartTime"
                :picker-options="{
                selectableRange: '00:00:00 - 23:59:59'
                }"
                placeholder="Thời gian bắt đầu ca">
            </el-time-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Thời gian kết thúc ca" prop="endTime">
            <el-time-picker
                v-model="dataInput.endTime"
                @change="handleChangeEndTime"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
                :picker-options="{
                selectableRange: '00:00:00 - 23:59:59'
                }"
                placeholder="Thời gian kết thúc ca">
            </el-time-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Trạng thái sử dụng" prop="isActive">
            <el-radio-group v-model="dataInput.isActive">
              <el-radio :label="true">Đang sử dụng</el-radio>
              <el-radio :label="false">Ngừng sử dụng</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Bộ phận áp dụng" prop="objectType">
            <el-select
                v-model="dataInput.teamType"
                disabled
                placeholder="Chọn bộ phận"
            >
              <el-option
                  v-for="item in listTeamType"
                  :key="item.key"
                  :value="item.value"
                  :label="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Đối tượng áp dụng" prop="objectType">
            <el-select
                disabled
                v-model="dataInput.targetType"
                placeholder="Chọn đối tượng"
            >
              <el-option
                  v-for="item in listObjectType"
                  :key="item.key"
                  :value="item.value"
                  :label="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <el-form-item label="Chọn ngày trong tuần" prop="applyDays">
            <el-checkbox-group v-model="selectedDays" @change="updateDaysString">
              <el-checkbox v-for="day in days" :key="day.value" :label="day.value">
                {{ day.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7">
          <el-form-item label="Điểm danh tự động" prop="autoAttendanceEnable">
            <el-radio-group v-model="dataInput.autoAttendanceEnable" @change="handleChangeAutoAttendance">
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="this.dataInput.autoAttendanceEnable === true">
          <el-form-item label="Nguồn áp dụng" prop="autoAttendanceSource">
            <el-select
                disabled
                v-model="dataInput.autoAttendanceSource"
                placeholder="Chọn nguồn"
            >
              <el-option
                  v-for="item in listSource"
                  :key="item.key"
                  :value="item.value"
                  :label="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="9" v-if="this.dataInput.autoAttendanceEnable === true">
          <el-form-item label="Chọn thiết bị" prop="allowDeviceIds">
            <el-select
                v-model="selectedDeviceIds"
                placeholder="Chọn thiết bị"
                multiple
                collapse-tags
            >
              <el-option
                  v-for="item in listIdDevice"
                  :key="item.key"
                  :value="item.id"
                  :label="item.nameDevice"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="this.dataInput.autoAttendanceEnable === true">
        <el-col :span="12">
          <el-form-item label="Tự động bắt đầu vào ca" prop="checkinStartTime" label-width="240px">
            <el-time-picker
                v-model="dataInput.checkinStartTime"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
                :picker-options="{
                selectableRange: '00:00:00 - 23:59:59'
                }"
                placeholder="Tự động bắt đầu vào ca">
            </el-time-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Tự động kết thúc vào ca" prop="checkinEndTime" label-width="240px">
            <el-time-picker
                v-model="dataInput.checkinEndTime"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
                :picker-options="{
                selectableRange: '00:00:00 - 23:59:59'
                }"
                placeholder="Tự động kết thúc vào ca">
            </el-time-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="this.dataInput.autoAttendanceEnable === true">
        <el-col :span="12">
          <el-form-item label="Tự động bắt đầu kết thúc nghỉ ca" prop="checkoutStartTime" label-width="240px">
            <el-time-picker
                v-model="dataInput.checkoutStartTime"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
                :picker-options="{
                selectableRange: '00:00:00 - 23:59:59'
                }"
                placeholder="Bắt đầu kết thúc nghỉ ca">
            </el-time-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Tự động bắt đầu kết thúc nghỉ ca" prop="checkoutEndTime" label-width="240px">
            <el-time-picker
                v-model="dataInput.checkoutEndTime"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
                :picker-options="{
                selectableRange: '00:00:00 - 23:59:59'
                }"
                placeholder="Kết thúc nghỉ ca">
            </el-time-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Tự động điểm danh ăn" prop="applyAttendanceEat">
            <el-radio-group v-model="dataInput.applyAttendanceEat" @change="handleChangeAutoAttendance">
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="this.dataInput.applyAttendanceEat === true">
          <el-form-item label="Chọn bữa ăn áp dụng" prop="meals">
            <el-select
                v-model="meals"
                placeholder="Chọn bữa ăn"
                multiple
                collapse-tags
            >
              <el-option
                  v-for="item in valueAttendanceEatList"
                  :key="item.key"
                  :value="item.value"
                  :label="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" size="medium" @click="closeDialog()">
        <i class="el-icon-circle-close"/>
        <span>{{ $t("button.close") }}</span>
      </el-button>
      <el-button
          type="success"
          size="medium"
          :loading="loadingButton"
          mini
          @click="submitForm()"
      >
        <i class="el-icon-circle-check"/>
        <span>{{ $t("button.save") }}</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import RecognitionManagerService from "@/services/SchoolService/RecognitionManagerService";
import shiftMaster from "@/services/ShiftMaster";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "UpdateShiftMasterDialog",
  props: {
    isOpenUpdateShiftMasterDialog: {
      type: Boolean,
      default: () => false
    },
    dataUpdate: {
      type: Object,
      default: () => {
      }
    },

  },

  data() {
    return {
      dataInput: {
        id: "",
        name: "",
        description: "",
        startTime: "",
        endTime: "",
        isActive: true,
        objectType: "STUDENT",
        applyDays: "",
        autoAttendanceEnable: false,
        autoAttendanceSource: "DEVICE",
        allowDeviceIds: "0",
        checkinStartTime: "",
        checkinEndTime: "",
        checkoutStartTime: "",
        checkoutEndTime: "",
        teamType: "",
        applyAttendanceEat: false,
        meals: "",
      },
      meals: [],
      listTeamType: [
        {key: 1, value: "CLASS", label: "Lớp"},
        {key: 2, value: "GROUP", label: "Nhóm"},
        {key: 3, value: "DEPARTMENT", label: "Phòng ban"},
      ],
      listObjectType: [
        {key: 1, value: "STUDENT", label: "Học sinh"},
        {key: 2, value: "TEACHER", label: "Nhân sự"},
      ],
      listSource: [
        {key: 1, value: "ALL", label: "Tất cả"},
        {key: 2, value: "DEVICE", label: "Thiết bị AI"},
      ],
      valueAttendanceEatList: [
        {key: "EAT_BREAKFAST", value: "eatBreakfast", label: "Bữa sáng"},
        {key: "EAT_BREAKFAST_SECOND", value: "eatBreakfastSecond", label: "Bữa phụ sáng"},
        {key: "EAT_LUNCH", value: "eatLunch", label: "Bữa trưa"},
        {key: "EAT_AFTERNOON", value: "eatAfternoon", label: "Bữa chiều"},
        {key: "EAT_AFTERNOON_SECOND", value: "eatAfternoonSecond", label: "Bữa phụ chiều"},
        {key: "EAT_DINNER", value: "eatDinner", label: "Bữa tối"},
      ],
      days: [
        {label: 'Thứ 2', value: 1},
        {label: 'Thứ 3', value: 2},
        {label: 'Thứ 4', value: 3},
        {label: 'Thứ 5', value: 4},
        {label: 'Thứ 6', value: 5},
        {label: 'Thứ 7', value: 6},
        {label: 'Chủ nhật', value: 7},
      ],
      selectedDays: [1, 2, 3, 4, 5, 6],
      loadingButton: false,
      listIdDevice: [],
      selectedDeviceIds: [],
      rules: {
        name: [
          {
            required: true,
            message: "Tên ca không được để trống",
            trigger: "blur",
          },
        ],
        startTime: [
          {
            required: true,
            message: "Thời gian không được để trống",
            trigger: "blur",
          },
        ],
        endTime: [
          {
            required: true,
            message: "Thời gian để trống",
            trigger: "blur",
          },
        ],
        targetType: [
          {
            required: true,
            message: "Đối tượng không được để trống",
            trigger: "blur",
          },
        ],
        applyDays: [
          {
            required: true,
            message: "Thời gian áp dụng không được để trống",
            trigger: "blur",
          },
        ],
        checkinStartTime: [
          {
            required: true,
            message: "Thời gian không được để trống",
            trigger: "blur",
          },
        ],
        checkinEndTime: [
          {
            required: true,
            message: "Thời gian không được để trống",
            trigger: "blur",
          },
        ],
        checkoutStartTime: [
          {
            required: true,
            message: "Thời gian không được để trống",
            trigger: "blur",
          },
        ],
        checkoutEndTime: [
          {
            required: true,
            message: "Thời gian không được để trống",
            trigger: "blur",
          },
        ],
        allowDeviceIds: [
          {
            required: true,
            message: "Thiết bị không được để trống",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    allowDeviceIdsString() {
      return this.selectedDeviceIds.join(',')
    },
  },
  methods: {
    handleOpen() {
      this.getListDeviceRecognition();
      this.dataInput = this.$props.dataUpdate && Object.keys(this.$props.dataUpdate).length > 0
          ? {...this.$props.dataUpdate}
          : {
            id: "",
            name: "",
            description: "",
            startTime: "",
            endTime: "",
            isActive: true,
            targetType: "STUDENT",
            applyDays: "",
            autoAttendanceEnable: false,
            autoAttendanceSource: "DEVICE",
            allowDeviceIds: "0",
            checkinStartTime: "",
            checkinEndTime: "",
            checkoutStartTime: "",
            checkoutEndTime: "",
            teamType: "",
            applyAttendanceEat: false,
            meals: "",
          };
      this.selectedDeviceIds = this.dataInput.allowDeviceIds
          .split(",")
          .map(id => Number(id));
      if (this.dataInput.meals !== "" && this.dataInput.meals !== null && this.dataInput.meals !== undefined ) {
        this.meals = this.dataInput.meals.split(",")
      }
    },
    updateDaysString() {
      // Sắp xếp và chuyển sang chuỗi
      this.dataInput.applyDays = this.selectedDays.sort((a, b) => a - b).join(',')
    },
    /**
     * Lấy danh sách thiết bị
     */
    async getListDeviceRecognition() {
      await RecognitionManagerService.getListDeviceRecognition().then((response) => {
        if (response.data.data.length > 0) {
          this.listIdDevice = response.data.data;
        }
      })
    },
    handleChangeAutoAttendance() {
      if (this.dataInput.autoAttendanceEnable === true) {
        this.getListDeviceRecognition();
        this.dataInput.allowDeviceIds = ""
      } else {
        this.dataInput.allowDeviceIds = "0"
      }
    },
    handleClear() {
      this.dataInput.id = "";
      this.dataInput.name = "";
      this.dataInput.description = "";
      this.dataInput.startTime = "";
      this.dataInput.endTime = "";
      this.dataInput.isActive = true;
      this.dataInput.objectType = "STUDENT";
      this.dataInput.applyDays = "";
      this.dataInput.autoAttendanceEnable = false;
      this.dataInput.autoAttendanceSource = "DEVICE";
      this.dataInput.allowDeviceIds = "0";
      this.dataInput.checkinStartTime = "";
      this.dataInput.checkinEndTime = "";
      this.dataInput.checkoutStartTime = "";
      this.dataInput.checkoutEndTime = "";
      this.dataInput.teamType = "";
      this.dataInput.applyAttendanceEat = false;
      this.dataInput.meals = "";
      this.meals = []
    },

    handleChangeStartTime() {
      // Gán giá trị bắt đầu
      this.dataInput.checkinStartTime = this.dataInput.startTime

      // Chuyển startTime (HH:mm:ss) → Date
      const [h, m, s] = this.dataInput.startTime.split(':').map(Number)
      const date = new Date()
      date.setHours(h, m + 10, s) // cộng 10 phút

      // Format lại thành HH:mm:ss
      const hh = String(date.getHours()).padStart(2, '0')
      const mm = String(date.getMinutes()).padStart(2, '0')
      const ss = String(date.getSeconds()).padStart(2, '0')

      this.dataInput.checkinEndTime = `${hh}:${mm}:${ss}`
    },
    handleChangeEndTime() {
      this.dataInput.checkoutStartTime = this.dataInput.endTime;
      // Chuyển startTime (HH:mm:ss) → Date
      const [h, m, s] = this.dataInput.endTime.split(':').map(Number)
      const date = new Date()
      date.setHours(h, m + 10, s) // cộng 10 phút

      // Format lại thành HH:mm:ss
      const hh = String(date.getHours()).padStart(2, '0')
      const mm = String(date.getMinutes()).padStart(2, '0')
      const ss = String(date.getSeconds()).padStart(2, '0')

      this.dataInput.checkoutEndTime = `${hh}:${mm}:${ss}`
    },
    //reset when click x
    closeDialog() {
      this.handleClear()
      this.$emit("dialog-close");
      setTimeout(() => {
        this.loadingButton = false;
        this.$refs["dataInput"].resetFields();
      }, 300);
    },
    submitForm() {
      this.updateDaysString();
      this.dataInput.allowDeviceIds = this.allowDeviceIdsString
      this.dataInput.meals = this.meals.join(',')
      this.$refs["dataInput"].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          shiftMaster.updateShift(this.dataInput.id, this.dataInput)
              .then(() => {
                NotifyMessage.leftCornerNotificationSuccess("Cập nhật ca thành công!")
                setTimeout(() => {
                  this.closeDialog();
                }, 500);
              })
              .catch((err) => {
                console.log(err)
                NotifyMessage.leftCornerNotificationError("Cập nhật ca thất bại!");
              })
              .finally(() => {
                setTimeout(() => {
                  this.loadingButton = false;
                }, 500);
              });
        } else {
          console.log("error validate data!");
          return false;
        }
      });
    },

  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-dialog__body {
  padding-bottom: 5px;
}

/deep/ .el-input-number__decrease,
/deep/ .el-input-number__increase {
  z-index: 1;
}

.el-input-number {
  width: 100%;
}
</style>
